import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import language from '../../../utils/LanguageSettings';
import { fetchBlog } from '../../functions/fetchBlog';
import RenderSnA from '../../functions/renderSnA';
import 'swiper/css/bundle';
import FilteredArticles from './FilteredArticles';
import Categories from './RightSection/Categories';
import SlideBarArticles from './RightSection/SlideBarArticles';
import Keywords from './RightSection/Keywords';
import whatsappWImg from '../../../images/icon/whatsapp-w.svg';
import webWImg from '../../../images/icon/web-w.svg';
import { getLocalizedData } from '../../functions/getLocalizedData';

const BlogFilter: React.FC = () => {
  const { cid } = useParams<{ cid: string }>();
  const blogFilterHash = decodeURIComponent(window.location.hash).substring(1);
  const [blogData, setBlogData] = useState<any>(null);
  const [category, setCategory] = useState<any>(null);
  const [filteredCategoryArticles, setFilteredCategoryArticles] = useState<any>(null);
  const [filteredKeywordArticles, setFilteredKeywordArticles] = useState<any>(null);
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);
  const articlesPerPage = 10;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const getBlogData = async () => {
      const blog = await fetchBlog(language);
      if (blog) {
        setBlogData({
          filterPageCategories: blog.data.attributes.FilterPageCategories.Categories,
          filterPageKeywords: blog.data.attributes.FilterPageKeywords,
          articles: blog.data.attributes.Articles,
          latestArticles: blog.data.attributes.Articles
            .sort((a: any, b: any) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime())
            .slice(0, 10),
          categoryHotPickArticles: blog.data.attributes.CategoryHotPickArticles.slice(0, 10)
        });

        cid && (cid === '最新文章' || blog.data.attributes.FilterPageCategories.Categories.includes(cid)) ? setCategory(cid) : setCategory(null);
        const filteredCategoryArticles = cid ? (cid === '最新文章' ? blog.data.attributes.Articles.sort((a: any, b: any) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime()).slice(0, 10) : blog.data.attributes.FilterPageCategories.Categories.includes(cid) ? blog.data.attributes.Articles.filter((article: any) => article.attributes?.Categories?.Categories?.includes(cid)).sort((a: any, b: any) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime()) : null) : null;
        setFilteredCategoryArticles(filteredCategoryArticles);

        const filteredKeywordArticles = blogFilterHash ? blog.data.attributes.Articles.filter((article: any) => article.attributes?.Hashtags?.some((item: any) => item.Hashtags === blogFilterHash)).sort((a: any, b: any) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime()) : null;
        setFilteredKeywordArticles(filteredKeywordArticles);

        setSeo(blog.data.attributes.SEO || null);
        setGa(blog.data.attributes.GA || null);

      }
    };

    getBlogData();
  }, [cid, blogFilterHash]);

  return (
    <>
      {blogData && (
        <>
          <RenderSnA seo={seo} ga={ga} />
          <div className="blog-wrapper subpage">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="heading">
                    <h1>{category ? getLocalizedData(category, language): blogFilterHash ? `關鍵字：${blogFilterHash}` : ''}</h1>
                  </div>

                  <FilteredArticles
                    filteredArticles={filteredCategoryArticles ? filteredCategoryArticles : filteredKeywordArticles ? filteredKeywordArticles : []}
                    articlesPerPage={articlesPerPage}
                    type={`blog_filter_${category ? category : blogFilterHash ? blogFilterHash : ''}`}
                  />

                </div>

                <div className="col-lg-4">
                  <div className="slide-sections-wrapper">
                    <Categories categories={blogData.filterPageCategories} />
                    {cid && cid === '最新文章' ? <SlideBarArticles slideBarArticles={blogData.categoryHotPickArticles} type={"categoryHotPickArticles"} /> : <SlideBarArticles slideBarArticles={blogData.latestArticles} type={"latestArticles"} />}
                    <Keywords keywords={blogData.filterPageKeywords} />
                  </div>
                </div>
              </div>
            </div>

            <div className="contacts-row-wrapper">
              <div className="container">
                <div className="d-flex justify-content-center">
                  <a href="https://api.whatsapp.com/send?phone=85296133533" target="_blank" className="btn"><img src={whatsappWImg} alt="" /> Whatsapp 查詢</a>
                  <a href="https://www.nowtv.now.com/get-started/" className="btn"><img src={webWImg} alt="" /> 網上訂購</a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BlogFilter;